module.exports = __webpack_public_path__ + "img/7.c002a41f.svg";